"use client";

import {
  trackWorkshopPrivateLinkAccessed,
  trackWorkshopRegistrationClosed,
  trackWorkshopRegistrationViewed,
} from "@/lib/analytics/workshops";
import { startDataDogView } from "@/lib/analytics/trackDataDogAction";
import { useEffect } from "react";

export function WorkshopRegistrationAnalytics({
  workshopId,
  language,
  isClosed,
  isPrivateLink,
}: {
  workshopId: number;
  language: string;
  isClosed: boolean;
  isPrivateLink: boolean;
}) {
  useEffect(() => {
    startDataDogView("workshop_registration");
    trackWorkshopRegistrationViewed(workshopId, { language });
    if (isPrivateLink) {
      trackWorkshopPrivateLinkAccessed(workshopId);
    }
    if (isClosed) {
      trackWorkshopRegistrationClosed(workshopId, { language });
    }
  }, [workshopId, language, isClosed, isPrivateLink]);

  return null;
}
